<div class="faceted-filter-panel-content-container text-base md:text-sm scrollable-x scrollbar-thin scrollbar-thumb-blue-200 scrollbar-thumb-rounded-md scrollbar-track-blue-50 hover:scrollbar-thumb-blue-200">

  @if (isSearching) {
    <div class="w-full h-full">
      @if (searchResults$ | async; as searchResults) {
        <div class="search-result-container">
          <div class="w-full h-14 flex items-center px-3 py-3 text-gray-900 font-medium border-b border-gray-100">
            <span>{{searchResults?.length}}</span>&nbsp;<span>Results</span>
          </div>
          @for (result of searchResults; track result; let even = $even) {
            <div class="w-full min-h-[56px] py-1 flex flex-col justify-center text-gray-900 font-inter border-b border-gray-200 cursor-pointer panel-option"
              [ngClass]="{'bg-gray-50': even}" (click)="onSearchResultItemSelected(result)">
              <div class="px-3 font-medium">{{result.label}}</div>
              <div class="px-3 text-sm font-normal">{{result.path}}</div>
            </div>
          }
        </div>
      } @else {
        <div class="w-full h-full flex items-center justify-center">
          No results for search.
        </div>
      }
    </div>
  } @else {
    @if (filterDataItems) {
      <div class="pane root-pane">
        @for (item of filterDataItems; track item) {
          <div [ngClass]="{'active': selectedRootItem?.label === item.label}" class="panel-option w-full h-10 flex items-center px-3 py-3 text-gray-900 font-medium cursor-pointer border-b border-gray-300"
            (click)="onRootItemSelected(item);">
            <div class="flex-1">{{item.label}}</div>
            @if (item.items) {
              <continuation-indicator [isActive]="selectedRootItem?.label === item.label"></continuation-indicator>
            }
          </div>
        }
      </div>
    } @else {
      <div class="w-full h-full flex items-center justify-items-center">
        No Filter In
      </div>
    }
  }


  <ng-container #paneComponentHost></ng-container>



</div>
